import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconArrowSmallBack = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 48,
	height: 48,
	fill: "none",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#111",
		fillRule: "evenodd",
		d: "M28 28.973 26.478 30.5 20 24l6.478-6.5L28 19.027 23.055 24 28 28.973z",
		clipRule: "evenodd"
	})
});
export default SvgIconArrowSmallBack;
